/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAnalyticsMissionsDataItem
 */
export interface OutputAnalyticsMissionsDataItem {
    /**
     * 
     * @type {string}
     * @memberof OutputAnalyticsMissionsDataItem
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAnalyticsMissionsDataItem
     */
    dimension: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAnalyticsMissionsDataItem
     */
    value: number;
}

/**
 * Check if a given object implements the OutputAnalyticsMissionsDataItem interface.
 */
export function instanceOfOutputAnalyticsMissionsDataItem(value: object): boolean {
    if (!('dimension' in value)) return false;
    if (!('value' in value)) return false;
    return true;
}

export function OutputAnalyticsMissionsDataItemFromJSON(json: any): OutputAnalyticsMissionsDataItem {
    return OutputAnalyticsMissionsDataItemFromJSONTyped(json, false);
}

export function OutputAnalyticsMissionsDataItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAnalyticsMissionsDataItem {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : json['date'],
        'dimension': json['dimension'],
        'value': json['value'],
    };
}

export function OutputAnalyticsMissionsDataItemToJSON(value?: OutputAnalyticsMissionsDataItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'date': value['date'],
        'dimension': value['dimension'],
        'value': value['value'],
    };
}

